import React, { useEffect, useRef } from 'react';

const SuccessPage = () => {
  const hasDownloaded = useRef(false);

  useEffect(() => {
    if (hasDownloaded.current) return;

    const queryParams = new URLSearchParams(window.location.search);
    const imageSrc = queryParams.get('image');

    if (imageSrc) {
      const link = document.createElement('a');
      link.href = imageSrc;
      link.download = imageSrc.split('/').pop();
      document.body.appendChild(link); // required for Firefox
      link.click();
      document.body.removeChild(link);
      hasDownloaded.current = true;
    }
  }, []);

  return (
    <div>
      <h1>Payment Successful!</h1>
      <p>Your payment was successful, and the image is downloading...</p>
    </div>
  );
};

export default SuccessPage;
